import React, { useEffect, useState } from "react"
import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import AllSingleItems from "../Single Item Master"
import { axiosbaseurl } from "configure"

const ServiceTagMaster = () => {
  const [services, setServices] = useState([])

  async function fetchServices() {
    try {
      const response = await axiosbaseurl.get(`/service-master/active`)
      if (response.data.success) 
      setServices(
        response.data.data
          .filter(
            item =>
              item.serviceCategory != "Non-Billiable and scheduled" &&
              item.serviceCategory != "Non-Billiable and Non-scheduled"
          )
          .map(service => ({
            value: service.id,
            label: service.serviceName,
          }))
      )
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchServices()
  }, [])

  document.title = "Service Tag Master | Peacock Accountants Limited"

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Service Tag Master"}
          />

          <Card className="px-0 mx-0">
            <CardBody>
              <AllSingleItems
                api_name={"service/tags"}
                heading={"Service Tag"}
                title={"Service Tag"}
                fieldName={"tagName"}
                services={services}
                module_id={31}
                isDelete={true}
                isAddDelete={true}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  )
}

export default ServiceTagMaster
